import AxiosService from "../../../gateway/rest/AxiosService"

class RESTProtectionConfigurationRestService {

    restProtectionConfigurationEndpoint = '/restprotection'

    getAll(): Promise<any> {
        return AxiosService.get(this.restProtectionConfigurationEndpoint)
    }

    getById(id: number): Promise<any> {
        return AxiosService.get(this.restProtectionConfigurationEndpoint + '/' + id)
    }

    getByAppId(appId: number): Promise<any> {
        return AxiosService.get(this.restProtectionConfigurationEndpoint + '/' + appId + '/endpoints')
    }

    getAllFieldConfigurations(): Promise<any> {
        return AxiosService.get(this.restProtectionConfigurationEndpoint + '/config')
    }

    create(endpointConfig: any): Promise<any> {
        return AxiosService.post(this.restProtectionConfigurationEndpoint, endpointConfig)
    }

    update(endpointConfig: any): Promise<any> {
        return AxiosService.put(this.restProtectionConfigurationEndpoint, endpointConfig)
    }

    delete(id: number) {
        return AxiosService.delete(this.restProtectionConfigurationEndpoint + '/' + id)
    }

    deleteByAppId(appId: number): Promise<any> {
        return AxiosService.delete(this.restProtectionConfigurationEndpoint + '/' + appId + '/endpoints')
    }

    getFieldConfigsForEndpointId(id: number): Promise<any> {
        return AxiosService.get(this.restProtectionConfigurationEndpoint + '/config/' + id)
    }

    addFieldConfigToEndpoint(fieldConfiguration: any): Promise<any> {
        return AxiosService.post(this.restProtectionConfigurationEndpoint + '/config/' + fieldConfiguration.endpointProfile, fieldConfiguration)
    }

    deleteFieldConfig(id: number): Promise<any> {
        return AxiosService.delete(this.restProtectionConfigurationEndpoint + '/config/' + id)
    }

    updateFieldConfig(fieldConfiguration: any): Promise<any> {
        return AxiosService.put(this.restProtectionConfigurationEndpoint + '/config', fieldConfiguration)
    }
}

export default new RESTProtectionConfigurationRestService()